<template>
  <section class="app-main">
    <div class="main-content">
      <div class="main-content-body">
        <div v-if="showtopbar" class="mybrand-topbar">
          <span v-if="pricedata.length == 1">{{ currentpkg.name }}</span>
          <el-dropdown v-if="pricedata.length > 1" trigger="click" split-button class="changebrandgroup" @command="brandClick">
            {{ currentpkg.name }}
            <el-dropdown-menu class="brandnamedrop" slot="dropdown">
              <el-dropdown-item 
                class="changebranditem" 
                v-for="(menu, index) in pricedata" 
                :key="index" 
                :command="menu.name"
                :disabled="currentpkg.name == menu.name"
              >
                <router-link :to="{name: menu.viewtype == 1 ? menu.subid != 257 ? 'PriceMonitoringProduct' : 'Linkstatus' : 'SPUPriceMonitoringProduct', 
                                  params: {Id: menu.subid}}">{{ menu.name }}</router-link>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <router-view :key="key" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    },
  },
  watch: {
    '$route' (to, from) {
      window.location.reload()
    }
  },  
  data(){
    return{
      pricedata: [],
      pkglist: {},
      currentpkg: {},
      showreportbtn: false,
      showtopbar: false,
    }
  },
  // beforeCreate(){
  //   $('.kf5-support-chat').remove()
  //   this.showtopbar = this.$route.path.indexOf('Personal') != -1 ? false : true
  // },
  mounted(){
    this.pricedata = JSON.parse(window.localStorage.getItem('price')).val
    this.pkglist = JSON.parse(localStorage.getItem("price")).val
    let currentpkg = this.pkglist.find(o => o.subid/1 === this.$route.params.Id/1)
    this.currentpkg = currentpkg
    this.showreportbtn = this.$moment(currentpkg.init).diff(this.$moment(new Date()), 'months') < 0 ? true : false
    this.showtopbar = this.$route.path.indexOf('Personal') != -1 ? false : true
  },
  methods: {

    /**
     * 切换品牌
     */
    brandClick: function(val){
      this.currentpkg = this.pkglist.find(o => o.name === val)
    },
  },
}
</script>